import { z } from "zod";
import { optional } from "./appointments";
import { membershipRole, membershipStatus, recordId } from "./contracts";
import { unset } from "./fields";

export const MEMBER_PAGE_SIZE_MAX = 100;

export const memberDetails = z.object({
  avatar: z.string().nullable(),
  description: z.string().nullable(),
  status: membershipStatus,
  joinedAt: z.string(),
});
export type MemberDetails = z.infer<typeof memberDetails>;

export const organizationMember = z.object({
  id: recordId,
  person: recordId,
  name: z.string(),
  email: z.string(),
  phone: z.string().nullable(),
  role: membershipRole,
  details: memberDetails.optional(),
});
export type OrganizationMember = z.infer<typeof organizationMember>;

export const memberListQuery = z.object({
  role: optional(membershipRole),
  status: optional(membershipStatus),
  order: z.preprocess(unset, z.enum(["asc", "desc"]).default("asc")),
  page: z.preprocess(unset, z.coerce.number().int().min(1).max(10_000).default(1)),
  pageSize: z.preprocess(unset, z.coerce.number().int().min(1).max(MEMBER_PAGE_SIZE_MAX).default(10)),
});
export type MemberListQuery = z.infer<typeof memberListQuery>;

export const memberPage = z.object({ items: z.array(organizationMember), total: z.number().int().nonnegative() });
export type MemberPage = z.infer<typeof memberPage>;

export const memberRoleRequest = z.object({ role: membershipRole }).strict();
export type MemberRoleRequest = z.infer<typeof memberRoleRequest>;

export const settableMemberStatus = z.enum(["active", "suspended"]);
export type SettableMemberStatus = z.infer<typeof settableMemberStatus>;

export const memberStatusRequest = z.object({ status: settableMemberStatus }).strict();
export type MemberStatusRequest = z.infer<typeof memberStatusRequest>;
